import { DEFAULT_OPTIMAL_PRICE_VALUE } from '@/config/CONSTANTS';
import { GETTER } from '@/store/wizard/deal/CONSTANTS';

export const POPUP_TYPES = {
  ENTRY: 'entry',
  SUBMIT: 'submit',
};

export function hasHomedayMaximumPrice(deal) {
  const price = deal?.homedayMaximumPrice;
  return typeof price === 'number' && price > 0;
}

export function getPopupAcknowledgments(deal) {
  return deal?.homedayMaximumPricePopupAcknowledgments || {};
}

export function isPopupAcknowledged(deal, popupType) {
  const acknowledgments = getPopupAcknowledgments(deal);

  if (popupType === POPUP_TYPES.ENTRY) {
    return Boolean(acknowledgments.entryAcknowledgedAt);
  }

  return Boolean(acknowledgments.submitAcknowledgedAt);
}

export function shouldShowEntryPopup(deal) {
  return hasHomedayMaximumPrice(deal) && !isPopupAcknowledged(deal, POPUP_TYPES.ENTRY);
}

export function shouldShowSubmitPopup(deal, optimalPrice) {
  if (!hasHomedayMaximumPrice(deal) || isPopupAcknowledged(deal, POPUP_TYPES.SUBMIT)) {
    return false;
  }

  return Math.round(optimalPrice) > Math.round(deal.homedayMaximumPrice);
}

export function getOptimalPriceForComparison(store) {
  const optimalPrice = store.getters[`wizard/currentDeal/${GETTER.OPTIMAL_PRICE}`];

  if (optimalPrice) {
    return optimalPrice;
  }

  const marketingPrice = store.getters[`wizard/currentDeal/${GETTER.MARKETING_PRICE}`];
  return marketingPrice * DEFAULT_OPTIMAL_PRICE_VALUE;
}

export function buildAcknowledgmentUpdate(deal, popupType, acknowledgedAt = new Date()) {
  const acknowledgments = {
    ...getPopupAcknowledgments(deal),
  };

  if (popupType === POPUP_TYPES.ENTRY) {
    acknowledgments.entryAcknowledgedAt = acknowledgedAt;
  } else {
    acknowledgments.submitAcknowledgedAt = acknowledgedAt;
  }

  return {
    homedayMaximumPricePopupAcknowledgments: acknowledgments,
  };
}
